"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: '広瀬香美 サポーターズ',
    organizationId: 'k0M9698vA7qZPxiZai5W',
    applicationKey: 'kohmihirose',
    applicationType: 'standalone',
    artistId: 'CLslF9OT3lSdczYPsRlqNdc9i012',
    version: '1.1',
    deeplinkUrl: 'https://kohmi-hirose-sp.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    deeplinkProd: 'kohmi-hirose-sp.utoniq.com',
    deeplinkStg: 'kohmihirose-stg.netlify.app',
    custom: {
        modules: {
            membership: true,
            prepaidPoint: { chargeable: false },
            liveStream: true,
            item: true,
            store: true,
            preSale: true,
            event: true,
            cart: true,
            konbiniPayment: true,
            mission: true,
        },
        tutorials: [
            'images/tutorial/Tutorial02.png',
            'images/tutorial/Tutorial04.png',
        ],
        globalTabs: [],
        artistTabs: ['home', 'postVideos', 'gallery', 'myProfile'],
    },
});
